import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import BottomNav from "@/components/BottomNav";
import CharacterCard from "@/components/CharacterCard";
import { UserRound, Plus } from "lucide-react";

export default function Library() {
  const [mine, setMine] = useState([]);
  const [personas, setPersonas] = useState([]);

  useEffect(() => {
    api.get("/characters/mine").then(({ data }) => setMine(data.characters));
    api.get("/personas").then(({ data }) => setPersonas(data.personas));
  }, []);

  return (
    <div className="mx-auto max-w-2xl px-4 pb-32 pt-safe-6">
      <header className="mb-6">
        <div className="font-display text-xs uppercase tracking-[0.35em] text-violet-400/80">My</div>
        <h1 className="font-display text-3xl leading-tight text-white">Library</h1>
      </header>

      <section className="mb-8">
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-xs uppercase tracking-[0.25em] text-neutral-500">Personas</h2>
          <Link to="/personas" data-testid="library-manage-personas" className="text-xs text-violet-300">Manage →</Link>
        </div>
        {personas.length === 0 ? (
          <Link to="/personas" data-testid="library-add-persona" className="flex items-center gap-3 rounded-2xl border border-dashed border-white/10 p-4 text-sm text-neutral-400 hover:bg-white/5">
            <UserRound size={18} /> Create your first persona
          </Link>
        ) : (
          <ul className="grid grid-cols-2 gap-2 sm:grid-cols-3">
            {personas.map((p) => (
              <li key={p.id} data-testid={`library-persona-${p.id}`} className="flex items-center gap-2 rounded-xl border border-white/5 bg-white/[0.02] p-2">
                {p.avatar_url ? (
                  <img src={p.avatar_url} alt="" className="h-10 w-10 rounded-lg object-cover" />
                ) : (
                  <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-fuchsia-500/20 text-fuchsia-200 font-display">
                    {p.name[0]}
                  </div>
                )}
                <div className="min-w-0">
                  <div className="text-sm text-white truncate">{p.name}</div>
                  <div className="text-[10px] text-neutral-500 truncate">{p.description}</div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </section>

      <section>
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-xs uppercase tracking-[0.25em] text-neutral-500">My characters</h2>
          <Link to="/create" data-testid="library-new-char" className="text-xs text-violet-300 flex items-center gap-1">
            <Plus size={12} /> New
          </Link>
        </div>
        {mine.length === 0 ? (
          <Link to="/create" data-testid="library-create-first" className="flex items-center justify-center rounded-2xl border border-dashed border-white/10 p-8 text-sm text-neutral-400 hover:bg-white/5">
            Create your first character
          </Link>
        ) : (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3" data-testid="library-chars-grid">
            {mine.map((c) => <CharacterCard key={c.id} character={c} testIdPrefix="library" />)}
          </div>
        )}
      </section>

      <BottomNav />
    </div>
  );
}
